<template>
  <div
    class="main-content"
    style="padding: 20px; background: #fff; min-height: 100%"
  >
    <div class="flex align-items marginBottom20">
      <el-button icon="el-icon-back" size="small" @click="goBack"
        >返回</el-button
      >
      <span class="marginLeft20" style="font-size: 16px; font-weight: bold"
        >业绩信息维护</span
      >
    </div>

    <div class="performance-tabs">
      <el-radio-group v-model="performanceTab" size="small">
        <el-radio-button label="L1">L1业绩信息</el-radio-button>
        <el-radio-button label="L2">L2业绩信息</el-radio-button>
      </el-radio-group>
    </div>

    <div class="flex align-items marginTop10 marginBottom10">
      <el-button type="primary" size="small" @click="handleAddPerformance"
        >新增业绩</el-button
      >
      <span class="marginLeft10">年份：</span>
      <el-date-picker
        v-model="performanceFilter.year"
        type="year"
        placeholder="根据搜索"
        size="small"
        style="width: 160px"
      />
      <el-button
        class="marginLeft10"
        size="small"
        @click="resetPerformanceSearch"
        >重置</el-button
      >
      <el-button type="primary" size="small" @click="getPerformanceList"
        >查询</el-button
      >
    </div>

    <div
      class="flex align-items marginBottom10"
      style="font-size: 14px; font-weight: bold"
    >
      <span style="color: #606266"
        >业绩金额总计：<span style="color: #409eff">{{
          totalPerformanceAmount || 0
        }}</span></span
      >
      <span class="marginLeft20" style="color: #606266"
        >可获取返利额总计(元)：<span style="color: #409eff">{{
          totalAvailableRebate || 0
        }}</span></span
      >
    </div>

    <el-table
      :data="performanceList"
      v-loading="performanceLoading"
      border
      size="small"
    >
      <el-table-column
        key="index"
        type="index"
        label="序号"
        width="60"
        align="center"
      />
      <el-table-column key="year" prop="year" label="年份" align="center" />
      <el-table-column
        key="seaCount"
        v-if="performanceTab === 'L2'"
        prop="seaCount"
        label="SEA数智盘柜台数"
        align="center"
      />
      <el-table-column
        key="performanceAmount"
        prop="performanceAmount"
        label="业绩金额"
        align="center"
      />
      <el-table-column
        key="rebateCoefficient"
        prop="rebateCoefficient"
        label="返利系数"
        align="center"
      >
        <template slot-scope="{ row }">
          {{ row.rebateCoefficient ? row.rebateCoefficient + "%" : "" }}
        </template>
      </el-table-column>
      <el-table-column
        key="availableRebate"
        prop="availableRebate"
        label="可获得返利额(元)"
        align="center"
      />
      <el-table-column
        key="rebateConfirm"
        prop="rebateConfirm"
        label="返利额确认状态"
        align="center"
      >
        <template slot-scope="{ row }">
          <span v-if="row.rebateConfirm === 1" style="color: #67C23A; font-weight: 500;">已确认</span>
          <span v-else-if="row.rebateConfirm === 0" style="color: #E6A23C; font-weight: 500;">待确认</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column key="action" label="操作" align="center" width="140">
        <template slot-scope="{ row, $index }">
          <el-button
            type="text"
            size="mini"
            @click="handleEditPerformance(row, $index)"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="mini"
            style="color: #ff001f"
            @click="handleDeletePerformance(row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑 业绩 小弹窗 -->
    <el-dialog
      :visible.sync="performanceDialogVisible"
      :title="performanceDialogTitle"
      width="30%"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form :model="performanceForm" label-width="140px">
        <el-form-item label="年份" required>
          <el-date-picker
            v-model="performanceForm.year"
            type="year"
            placeholder="选择年份"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item
          v-if="performanceTab === 'L2'"
          label="SEA数智盘柜台数"
          required
        >
          <el-input
            v-model="performanceForm.seaCount"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="业绩金额" required>
          <el-input-number
            v-model="performanceForm.performanceAmount"
            placeholder="请输入"
            :disabled="disabled"
            :min="0"
            :max="999999"
            :precision="2"
            controls-position="right"
          ></el-input-number>
          <!-- <el-input
            v-model="performanceForm.performanceAmount"
            placeholder="请输入"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="返利系数" required>
          <el-input-number
            v-model="performanceForm.rebateCoefficient"
            placeholder="请输入"
            :disabled="disabled"
            :min="0"
            :max="100"
            :precision="2"
            controls-position="right"
          ></el-input-number>
          <span style="margin-left: 8px">%</span>
          <!-- <el-input
            v-model="performanceForm.rebateCoefficient"
            placeholder="请输入"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="可获得返利额" required>
          <el-input-number
            v-model="performanceForm.availableRebate"
            placeholder="请输入"
            :disabled="disabled"
            :min="0"
            :max="999999"
            :precision="2"
            controls-position="right"
          ></el-input-number>
          <!-- <el-input
            v-model="performanceForm.availableRebate"
            placeholder="请输入"
          ></el-input> -->
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="flex" style="justify-content: center">
          <el-button @click="performanceDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmPerformance"
            >保 存</el-button
          >
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from "element-ui";
import dayjs from "dayjs";
import {
  factoryPerformanceList,
  factoryPerformanceAdd,
  factoryPerformanceUpdate,
  factoryPerformanceDelete,
  factoryPerformanceTotal,
} from "@/api/factory/manage";

export default {
  name: "PerformancePage",
  data() {
    return {
      factoryId: null,

      performanceTab: "L1",
      performanceFilter: { year: "" },
      performanceList: [],
      performanceLoading: false,
      performancePage: {
        currentPage: 1,
        pageSize: 999,
        total: 0,
      },
      performanceDialogVisible: false,
      performanceDialogTitle: "",
      performanceForm: {},
      performanceEditIndex: -1,
      totalPerformanceAmount: 0,
      totalAvailableRebate: 0,
    };
  },
  watch: {
    performanceTab() {
      if (this.factoryId) {
        this.getPerformanceList();
      }
    },
  },
  created() {
    if (this.$route.query.id) {
      this.factoryId = this.$route.query.id;
      this.getPerformanceList();
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    async getPerformanceList() {
      if (!this.factoryId) {
        this.performanceList = [];
        return;
      }
      this.performanceLoading = true;
      try {
        const year = this.performanceFilter.year
          ? dayjs(this.performanceFilter.year).format("YYYY")
          : "";
        const res = await factoryPerformanceList({
          page: this.performancePage.currentPage,
          size: this.performancePage.pageSize,
          factoryId: this.factoryId,
          performanceLevel: this.performanceTab,
          year,
        });
        if (res.code === 200) {
          const data = res.data || {};
          this.performanceList = data.records || [];
          this.performancePage.total = data.total || 0;
        }

        const totalRes = await factoryPerformanceTotal({
          factoryId: this.factoryId,
          performanceLevel: this.performanceTab,
          year,
        });
        if (totalRes.code === 200 && totalRes.data) {
          const item = Array.isArray(totalRes.data)
            ? totalRes.data[0] || {}
            : totalRes.data;
          this.totalPerformanceAmount = item.totalPerformanceAmount || 0;
          this.totalAvailableRebate = item.totalAvailableRebate || 0;
        } else {
          this.totalPerformanceAmount = 0;
          this.totalAvailableRebate = 0;
        }
      } finally {
        this.performanceLoading = false;
      }
    },
    resetPerformanceSearch() {
      this.performanceFilter.year = "";
      this.getPerformanceList();
    },
    handleAddPerformance() {
      this.performanceEditIndex = -1;
      this.performanceForm = {
        factoryId: this.factoryId,
        performanceLevel: this.performanceTab,
      };
      this.performanceDialogTitle = `新增${this.performanceTab}业绩`;
      this.performanceDialogVisible = true;
    },
    handleEditPerformance(row, index) {
      this.performanceEditIndex = index;
      this.performanceForm = { ...row };
      this.performanceDialogTitle = `编辑${this.performanceTab}业绩`;
      this.performanceDialogVisible = true;
    },
    handleDeletePerformance(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await factoryPerformanceDelete(row.id);
        if (res.code === 200) {
          Message.success("删除成功");
          this.getPerformanceList();
        }
      });
    },
    async confirmPerformance() {
      if (!this.factoryId) {
        Message.warning("缺少盘厂ID");
        return;
      }
      const data = {
        ...this.performanceForm,
        factoryId: this.factoryId,
        performanceLevel: this.performanceTab,
        year: this.performanceForm.year
          ? dayjs(this.performanceForm.year).format("YYYY")
          : "",
      };
      const res = data.id
        ? await factoryPerformanceUpdate(data)
        : await factoryPerformanceAdd(data);
      if (res.code === 200) {
        Message.success("保存成功");
        this.getPerformanceList();
      }
      this.performanceDialogVisible = false;
    },
  },
};
</script>

<style scoped>
.performance-tabs {
  margin-bottom: 20px;
}
</style>
